export default "__VITE_ASSET__5b38b805__"